import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAtom } from 'jotai';
import RankingRuleCreateForm from 'components/RankingRule/RankingRuleCreateForm';
import {
  rankingRuleTriggerModalAtom,
  rankingRuleTargetModalAtom,
} from '../../atoms/ranking';
import { RankingRuleActionType } from 'types/ranking';

export default function CreateRankingRule() {
  const location = useLocation();
  const [triggerModal, setTriggerModal] = useAtom(rankingRuleTriggerModalAtom);
  const [targetModal, setTargetModal] = useAtom(rankingRuleTargetModalAtom);

  useEffect(() => {
    setTriggerModal({
      visible: false,
      type: '',
      cascadingConcepts: [],
      exactConcepts: [],
      exactKeywords: [],
      phraseKeywords: [],
      partialKeywords: [],
    });
    setTargetModal({
      type: '',
      actionType: RankingRuleActionType.Boost,
      visible: false,
      boosts: [],
      buries: [],
    });
  }, [location, setTargetModal, setTriggerModal]);
  return <RankingRuleCreateForm />;
}
